import React from 'react';
import { domToReact, attributesToProps } from 'html-react-parser';
import LearningCenterSourceIdLink from '../../../../../components/Molecules/LearningCenterSourceIdLink';
import { isValidLeadFormLink } from './Constants';
import getHomeUrl from '../../../../getHomeUrl';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const toLearningCenterSourceIdInlineLink = ( parserData ) => 
{
    const { articleId, parserOptions: { replaceFn } } = parserData;
    const Wrapper = ({ 
        type = parserPropTypesDefaults.type,
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }) => 
    {
        if ( type !== 'tag' ) return null;
        if (!attribs?.href) return null;
        try 
        {
            const url = new URL(attribs?.href, getHomeUrl());

            if (!isValidLeadFormLink(url)) return null;

            if (url.hash.indexOf( '#sourceid' ) < 0) 
            {
                const sourceid = url.searchParams.get('sourceid');
                url.hash = sourceid
                    ? `#sourceid-${sourceid}`
                    : '#sourceid-inline_link';
            }
            const childComponents = domToReact(children, replaceFn());
            const props = attributesToProps(attribs);

            return (
                <LearningCenterSourceIdLink
                    {...props}
                    href={url.href}
                    articleId={articleId}
                >
                    {childComponents}
                </LearningCenterSourceIdLink>
            );
        }
        catch (error) 
        {
            return null;
        }
    };
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
};

export default toLearningCenterSourceIdInlineLink;
